module.exports = __webpack_public_path__ + "static/media/rocket.076fbf9a.jpg";